import React, { useState, useEffect, useCallback,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import {
    Switch,
    Select,
    Input,
    Modal,
    Form
} from "@gpstrackit/gtc-react-controls";
import { Grid } from '@mui/material';
import  {Button}  from "Components/uiControls";
import { accountWebHooksCreateUpdate,accountSearchWebHooks,reset } from "../../redux/slice";
import {dataCatalogSamples} from "./constantSample"
import GlobalAlert from 'Components/GlobalAlert';
import { NotificationManager } from 'Components/Notifications';
import {Alert} from '@mui/material';

//Actions

//Styles
const CreateEditWebhook = (props) => {
    const { messages } = useIntl();
    const { refresh,getData } = props;
    const { open, loading,webhook,responseWebHooks,webHooks } = useSelector((state) => state.accountWebHooksRedux);
    const formRef = Form.useForm();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({status:false});
    const [headers, setHeaders] = useState([{}]);
    const [error, setError] = useState("");
    const [showConfirm, setShowConfirm] = useState(false)
    const [idDeleteHeader, setIdDeleteHeader] = useState(0)
    

    const optionsSelect = [
        { id: 'SystemAlertLog', name: messages["accountWebHooks_typeCatalog_SystemAlert"] },
        { id: 'DeviceReading', name: messages["accountWebHooks_typeCatalog_LastReading"]  },
        { id: 'Driver', name: messages["accountWebHooks_typeCatalog_Driver"]  },
        { id: 'Unit', name: messages["accountWebHooks_typeCatalog_Unit"]  },
        { id: 'VehicleInformation', name: messages["accountWebHooks_typeCatalog_VehicleInformation"]  },
        { id: 'WorkOrder', name: messages["accountWebHooks_typeCatalog_WorkOrder"]  }
    ];
    

    const handleClose = useCallback(() => {
        setError("")
        getData()
        setHeaders([{}])
        setFormData({status:false})
        dispatch(reset());
    });

    const handleDriverTaskSubmit = () => {
       let values = {...formData}
       setError("")


       let validateHeader=false;
       if(headers?.length){
            headers.forEach(h => {
                if (!h?.key  || !h?.value)
                    validateHeader=true
            });
       }

       if(validateHeader){
            setError(messages["accountWebHooks_error_headerFields"])
            return false;
       }

       var validateUrl = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/);
       if(!validateUrl.test(values?.url)){
            setError(messages["accountWebHooks_error_urlFormat"])
            return false;
        }

       if(headers?.length){
            values.headers=  headers.reduce((acc, { key, value }) => {
                                    acc[key] = value;
                                    return acc;
                            }, {});
       }else{
        values.headers=[]
       }

       dispatch(accountWebHooksCreateUpdate({...values,catalog:formData.catalog.id,status:formData?.status?1:0}))
    };

    useEffect(()=>{

        if(webhook?.id && open &&  formRef?.ref){
            let values = {...webhook,status:webhook?.status==1?true:false,catalog:optionsSelect.find((t) => t.id == webhook?.catalog)}

            if(webhook?.headers){
                let header= JSON.parse(webhook?.headers)
                header = Object.entries(header).map(([key, value]) => {
                    return { key: key, value: value.toString() }; 
                });

                setHeaders(header)
            } 
      
            setTimeout(() => { formRef.setValues(values) }, 100);

            setFormData(values)
        }else{
            setTimeout(() => { formRef.setValues({ status: true }) }, 500);
            setTimeout(() => {  setFormData({ ...formData, status: true }) }, 500);
        }
    },[webhook, formRef?.ref])

    useEffect(()=>{
        if(responseWebHooks?.id && open){
            NotificationManager.success(
                messages[webhook?.id ? 'accountWebHooks_updatedMessage' : 'accountWebHooks_createdMessage'],
                messages['accountWebHooks_success'],
                3000,
                null,
                null,
                'success',
                null
            );
            setTimeout(() => { dispatch(accountSearchWebHooks({})); }, 500);
            handleClose()
        }

        if(responseWebHooks?.error && open){
            setError(responseWebHooks?.error);
        }
    },[responseWebHooks])

    const filterOptionCatalog = (currentData, referenceData, currentWebhookId) => {
        if (!referenceData) return currentData;

        return currentData.filter(objP => {
            const countForCatalog = referenceData.filter(
                objR => objR.catalog === objP.id && objR.id !== currentWebhookId
            ).length;
            return countForCatalog < 3;
        });
    }

    

    return (
        <Modal
            title={webhook?.id?messages["accountWebHooks_title_edit"]:messages["accountWebHooks_title_create"]}
            open={open}
            loading={loading}
            position="right"
            style={{ zIndex: 3 }}
            size="small"
            handleClose={handleClose}
            footer={(
                <div>
                    <Button onClick={handleClose} className="btn-cancel" >
                        {messages['cancel']}
                    </Button>
                    <Button onClick={() => { formRef?.submit();}} className="btn-blue">
                        {messages['save']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '10px 30px' }}>
            {
                error && 
                <Alert severity="error" onClose={() => setError("")}>{error}</Alert>
            }
               
                <Form ref={formRef.ref} onValidSubmit={handleDriverTaskSubmit}>
                    <Form.Item
                        name="name"
                        label={messages['accountWebHooks_name']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="name"
                            type="text"
                            placeholder={messages['accountWebHooks_name']}
                            autoFocus
                            maxLength={30}
                            onChange={(value) => setFormData({ ...formData, name: value })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="url"
                        label={messages['accountWebHooks_url']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="url"
                            type="text"
                            placeholder={messages['accountWebHooks_url']}
                            autoFocus
                            maxLength={150}
                            onChange={(value) => setFormData({ ...formData, url: value })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="catalog"
                        label={messages['accountWebHooks_catalog']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Select
                            id="catalog"
                            options={filterOptionCatalog(optionsSelect, webHooks?.items, webhook?.id)}
                            textField="name"
                            placeholder={messages["accountWebHooks_catalog"]}
                            valueField="id"
                            style={{width:"100%"}}
                            onChange={(value) =>
                                setFormData({ ...formData, catalog: value })
                            }
                        />
                    </Form.Item>
                    <Form.Item
                        name="status"
                        label={messages['accountWebHooks_status']}
                    >
                        <Switch
                            id="status"
                            optionLabels={[ messages['dynamicFormsMain_active'],messages['dynamicFormsDesign_inactive']]}
                            size={"large"}
                            onChange={(value) =>
                                setFormData({ ...formData, status: value })
                            }
                        />
                    </Form.Item>
                </Form>
                <label className="input-normal-label"  style={{marginBottom:18}}>{messages["accountWebHooks_createEditHeaders"]}</label>
                <Button
                    type="icon"
                    icon="add_box"
                    placement="bottom"
                    disabled={headers.length>4}
                    tooltip={messages["add"]}
                    onClick={(e) => {
                        setHeaders([...headers, {}]);
                    }}
                />
                <div style={{ overflow: 'hidden auto' }}>
                    {
                        headers && headers.map((item, index) => {
                            return (
                                <Grid container direction="row" justifyContent="space-between" alignItems="center" key={`head${index}`}>
                                    <Grid item  sm={5} style={{ display: "flex",padding:5 }}>
                                        <Input
                                            id="key"
                                            type="text"
                                            placeholder={messages['accountWebHooks_createEditKey']}
                                            value={headers[index]?.key || ''}
                                            maxLength={30}
                                            onChange={(value) => {
                                                let headKey = [...headers];
                                                headKey[index]={...headKey[index],key:value};
                                                setHeaders(headKey);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item  sm={5} style={{ display: "flex",padding:5 }}>
                                        <Input
                                            id="name"
                                            type="text"
                                            placeholder={messages['accountWebHooks_createEditValue']}
                                            autoFocus
                                            value={headers[index]?.value || ''}
                                            maxLength={128}
                                            onChange={(value) => {
                                                let headValue= [...headers];
                                                headValue[index]={...headValue[index],value};
                                                setHeaders(headValue);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item  sm={1} style={{ display: "flex",padding:5 }}>
                                        <Button
                                            type="icon"
                                            icon="delete"
                                            placement="bottom"
                                            tooltip={messages["delete"]}
                                            onClick={(e) => {
                                                setIdDeleteHeader(index)
                                                setShowConfirm(true)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item  sm={1} style={{ display: "flex" }}></Grid>
                                </Grid>  
                            )
                        })
                    }
                </div>
                <div className="input-normal-label"  style={{paddingTop:16}}>{messages["accountWebHooks_createEditSample"]}</div>
                <Alert severity="info">{messages["accountWebHooks_helpField_sample"]}</Alert>
                <div style={{  overflow: 'hidden auto'}}>
                    {
                        formData?.catalog?.id &&
                        <div style={{ marginBottom: 30 }}>
                            <pre>
                                <div style={{ display: 'flex', width: '100%',  marginTop: 8, opacity: 0.5 }}>
                                    {JSON.stringify(dataCatalogSamples[`dataCatalog${formData?.catalog?.id}`], undefined, 2)}
                                </div>
                            </pre>
                        </div>
                    }
                </div>
            </div>
            <GlobalAlert
                open={showConfirm}
                title={`${messages['accountWebHooks_header_deleteTitle']}`}
                confirmText={messages['continue']}
                contentText={messages['accountWebHooks_header_deleteWarning']}
                type="success"
                cancelText={messages['cancel']}
                onClose={() => { setShowConfirm(false);setIdDeleteHeader(0) }}
                onClick={() => {
                    setShowConfirm(false)
                    const headDelete = [...headers];
                    headDelete.splice(idDeleteHeader, 1);
                    setHeaders(headDelete);
                    setIdDeleteHeader(0);
                }}
                loading={loading}
            />
        </Modal>);
};

export default CreateEditWebhook

